import React, { forwardRef, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
//import jsPDF from "jspdf";

//Services

import swal from "sweetalert";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  Checkbox,
  FormControlLabel,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";



import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { fr, enGB } from "date-fns/locale"; // import French and English locale

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { getFacilityListByGroup } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

import { format, subDays } from "date-fns";
const OrderApproval = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "order-approval";
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const { t, i18n } = useTranslation();

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;
  const userId = UserInfo == 0 ? "" : UserInfo[0].id;

  const DefaultFacilityId = localStorage.getItem("DefaultFacilityId");
  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(
    assignedProdGroupList.length,
  );
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];
  /* const RoleItemGroupId = UserInfo==0?'': UserInfo[0].ItemGroupId; */

  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);

  //const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;

  const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

  const [chosenValuesRegion, setChosenValuesRegion] = useState(objAll);

  const RegionlistLocal = JSON.parse(localStorage.getItem("Regionlist"));
  let All_Region_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All"]),
  };
  const Regionlist = [All_Region_label].concat(RegionlistLocal);
  const [currRegionId, setcurrRegionId] = useState(0);

  const handleRegionChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setcurrRegionId(rowId);

    setChosenValuesRegion(Regionlist.find((list) => list.id == rowId) ?? null);
  };

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrProductGroupId(rowId);
    setChosenValuesRegion(objAll);
    setcurrRegionId(0);
  };

  const StatusList = [
    {
      id: 2,
      name: t(DispensingLanguage[lan][menukey]["Complete"]),
      ColorCode: "#ffa500",
    },
    {
      id: 3,
      name: t(DispensingLanguage[lan][menukey]["Approve"]),
      ColorCode: "#008000",
    },
    {
      id: 4,
      name: t(DispensingLanguage[lan][menukey]["Receive"]),
      ColorCode: "#0000ff",
    },
  ];

  const [dataItems, setDataItems] = useState([]);

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 90), "yyyy-MM-dd"),
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
    setLoading(true);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), "yyyy-MM-dd"),
  );

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
    setLoading(true);
  };

  const queryClient = useQueryClient();

  const [isLoading, setLoading] = useState(true);
  const [checked, setChecked] = React.useState(true);

  const [CompletedOrders, setCompletedOrders] = useState(true);

  let params = {
    menukey: menukey,
    RegionId: currRegionId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    StartDate: selectedStartDate,
    EndDate: selectedEndDate,
    CompletedOrders: CompletedOrders,
    ItemGroupId: currProductGroupId,
    FacilityId: FacilityId,
  };
  const { error, isError, data, refetch } = useQuery(
    [params],
    api.getOrderInvApproval,
    {
      onSuccess: (data) => {
        setDataItems(data);
        setLoading(false);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    },
  );

  const { mutate } = useMutation(api.deleteOrderInv, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        refetch();
        queryClient.getQueriesData("order-approval");

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
          duration: 10000,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  const handleApproveChange = (event) => {
    setChecked(event.target.checked);
    setLoading(true);
    setCompletedOrders(event.target.checked);
  };

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let StartDate = format(new Date(selectedStartDate), "yyyy-MM-dd");
    let EndDate = format(new Date(selectedEndDate), "yyyy-MM-dd");
    let currRegionName = (
      Regionlist.find((list) => list.id == currRegionId) ?? null
    ).name;

    window.open(
      finalUrl +
        "?action=getExportOrdersBookApproval" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&RegionId=" +
        currRegionId +
        "&RegionName=" +
        currRegionName +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate +
        "&CompletedOrders=" +
        CompletedOrders +
        "&ItemGroupId=" +
        currProductGroupId +
        "&FacilityId=" +
        FacilityId +
        "&TimeStamp=" +
        Date.now(),
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editOrderInvs(rowData);
  };

  var StatusIcon = function (cell, formatterParams) {
    //plain text value
    const CellValueForOrder = cell._cell.row.data;

    if (CellValueForOrder.bReceived == 1) {
      return "<i class='fa fa-check' style='color:blue'></i>";
    } else {
      if (CellValueForOrder.bCompleted == 1) {
        return "<i class='fa fa-check' style='color:green'></i>";
      } else if (CellValueForOrder.bCompleted == 0) {
        return "<i class='fa fa-check' style='color:orange'></i>";
      } else if (CellValueForOrder.bCompleted == -1) {
        return "<i class='fa fa-times' style='color:red'></i>";
      }
    }
  };

  const columns = [
    { title: "Id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 70,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order Date"]),
      width: 110,
      field: "OrderDate",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return format(new Date(value), "dd/MM/yyyy");
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order No"]),
      field: "OrderNo",
      headerFilter: true,
      width: 230,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Facility"]),
      field: "OrderFromFacility",
      headerFilter: true,
      width: 230,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order To"]),
      field: "OrderTo",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Entry By"]),
      field: "EntryBy",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Approved By"]),
      field: "ApprovedByName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Status"]),
      field: "bCompleted",
      hozAlign: "center",
      width: 90,
      //formatter: "tickCross",
      formatter: StatusIcon,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerHozAlign: "center",
      headerSort: false,
      hozAlign: "center",
      width: 90,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editOrderInvs = (data) => {
    let route = `order-approval/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteOrderInvs = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this order!"
        ],
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        mutate(data.id);
      }
    });
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (rowData.bCompleted == 1 || permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editOrderInvs(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editOrderInvs(rowData);
            }}
          />

          {/* <DeleteOutline
            onClick={() => {
              deleteOrderInvs(rowData);
            }}
          /> */}
        </>
      );
  }

  return (
    <>
      <div className={classes.OrderPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {t(DispensingLanguage[lan][menukey]["Order"])}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                  <Grid item xs={2} sm={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                      <Grid container justifyContent="space-around">
                        <DatePicker
                          inputFormat="dd/MM/yyyy"
                          label={t(DispensingLanguage[lan][menukey]["From"])}
                          value={selectedStartDate}
                          onChange={handleStartDateChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              className={classes.fullWidth}
                              id="date-picker-inline"
                            />
                          )}
                        />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                      <Grid container justifyContent="space-around">
                        <DatePicker
                          inputFormat="dd/MM/yyyy"
                          label={t(DispensingLanguage[lan][menukey]["To"])}
                          value={selectedEndDate}
                          onChange={handleEndDateChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              className={classes.fullWidth}
                              id="date-picker-inline"
                            />
                          )}
                        />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="ProductGroupList"
                        disableClearable
                        //disabled={userId==1?false:true}
                        disabled={prodGroupCountUnderRole > 1 ? false : true}
                        options={ProductGroupList}
                        onChange={(event, newValue) =>
                          handleProductGroupChange(event, newValue)
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={
                          ProductGroupList.find(
                            (productGroupList) =>
                              productGroupList.id == currProductGroupId,
                          ) ?? null
                        }
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Product Group"]
                            }
                            variant="standard"
                            hiddenLabel
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="Regionlist"
                        disabled={currProductGroupId == 3 ? false : true}
                        disableClearable
                        options={Regionlist}
                        onChange={(event, newValue) =>
                          handleRegionChange(event, newValue)
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        defaultValue={
                          Regionlist.find((list) => list.id == currRegionId) ??
                          null
                        }
                        value={chosenValuesRegion}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Department"]
                            }
                            variant="standard"
                            hiddenLabel
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <FormControlLabel
                      className="OrderApprovalCheck"
                      control={
                        <Checkbox
                          color="primary"
                          name="bDispensingFilter"
                          checked={checked}
                          onChange={handleApproveChange}
                          //value="no"
                        />
                      }
                      label={DispensingLanguage[lan][menukey]["To be approved"]}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={7}>
                    <div className="mylegend_area OrderApprovalCheck">
                      <span className="float-start marginleft">
                        {DispensingLanguage[lan][menukey]["Status"] + ":  "}{" "}
                        &nbsp;
                      </span>

                      {StatusList.map((item, index) => {
                        return (
                          <div key={index} className="my_legend">
                            <div
                              className="mylegend_color"
                              style={{ background: item.ColorCode }}
                            ></div>
                            <div className="mylegend_label"> {item.name}</div>
                          </div>
                        );
                      })}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={5}>
                    <div className="float-end sw_btn_control">
                      {/* <Button
                        color="info"
                        className="me-2"
                        onClick={() => {
                          props.history.push("/order/add");
                        }}
                      >
                        {t(DispensingLanguage[lan][menukey]["Add Order"])}
                      </Button> */}

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("print")}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("excel")}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="450px"
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
              /*  options={{
                //groupBy: ["GroupName", "ItemName"],
                groupBy: "FacilityName",
                columnCalcs: "both",
              }} */
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderApproval;

const useStyles = makeStyles({
  OrderPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
